import { IImageModalDetail } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//이미지 상세페이지(모달)에 보여줄 이미지 식별 정보(옵션 밸류)와 태그 불러오기
async function getImageDetail(imageId?: number): Promise<AxiosResponse<FetchResult<IImageModalDetail>>> {
  const response = await instance.get(`/images/detail?imageId=${imageId}`);
  return response;
}

const useFetchImageDetail = (imageId?: number) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/images/detail?imageId=${imageId}`],
    queryFn: () => getImageDetail(imageId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(imageId)
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchImageDetail;
